import {
  Badge,
  Button,
  Card,
  Form,
  Icon,
  Input,
  notification,
  Switch,
  Table,
  Tooltip
} from 'antd'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { SendTemplateEmail } from '../../../email/actions'
import { getAllAbstracts,ApproveAbstract } from '../actions' // Updated import
import AbstractActivityList from '../AbstractActivityList'
import AbstractFilters from './AbstractFilters' // Ensure this matches your abstract filter component
import AcceptanceAbstractDrawer from './AcceptanceAbstractDrawer'

@Form.create()
class ApprovedAbstract extends Component {
  state = {
    filters: {},
    visibleDrawer: false,
    abstract: {},
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Approved Abstract' // Filter for abstract status
      }
      let data = await dispatch(getAllAbstracts({ ...obj }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => { this.table.current.reload() }

  reloadTable = data => {
    if (data.fromDate && data.toDate) {
      data['submittedDate'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  // handleResendApprove = record => {
  //   let { dispatch } = this.props
  //   chooseEmailModalFxn({
  //     callback: async email => {
  //       let obj = {
  //         id: record._id,
  //         fromEmail: email,
  //         template: 'approvedAbstract',
  //         type: 'abstract',
  //         attachmentArr: ['invoice']
  //       }
  //       let resp = await dispatch(
  //         SendTemplateEmail({
  //           email: obj.fromEmail,
  //           id: record._id,
  //           obj,
  //           template: obj.template
  //         })
  //       )
  //       if (resp && resp.success) {
  //         this.reload()
  //       }
  //     }
  //   })
  // }
  handleResendApprove = record => {
    let { dispatch } = this.props;

    chooseEmailModalFxn({
      callback: async email => {
        const valData = {
          abstractId: record._id,
          fromEmail: email,
          template: 'approvedAbstract',
          isUpdate: true,
          sendEmail: true,
          affiliationData: record.affiliationData,
          publicationCharges: record.publicationCharges,
          doiAuthors: record.doiAuthors,
          noOfAuthors: record.noOfAuthors
        };

        // Dispatch the specific ApproveAbstract action
        let { success } = await dispatch(ApproveAbstract(valData));

        if (success) {
          notification.success({
            message: 'Success',
            description: 'Approved abstract email resent successfully.'
          });

          dispatch({ type: 'START_LOAD_ABSTRACT' });
          this.reload();
        }
      }
    });
  }
  render() {
    const columns = [
      {
        key: 'actions',
        title: 'Abstract No',
        width: '85px',
        render: (val, record) => (
          <Tooltip title="View Details">
            <a href={`/abstract/view/${record._id}`}>{record.abstractNo || record.onlineAbstractId}</a>
          </Tooltip>
        )
      },
      {
        title: 'Submitted Date',
        key: 'submittedDate',
        dataIndex: 'submittedDate',
        width: '100px',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Abstract Title',
        key: 'titleOfAbstract',
        width: '200px',
        dataIndex: 'titleOfAbstract',
        render: item => item ? ReactHtmlParser(item) : null
      },
      {
        title: 'Country',
        key: 'country',
        dataIndex: 'country'
      },
      {
        title: 'Author',
        key: 'authorName',
        dataIndex: 'authorName'
      },
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email'
      },
      {
        title: 'Approval Date',
        key: 'approvedAbstractDate',
        width: 100,
        dataIndex: 'approvedAbstractDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Approval Amount',
        key: 'publicationCharges',
        dataIndex: 'publicationCharges'
      },
      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => (
          <>
            <Button onClick={() => this.handleResendApprove(record)} className={'roundSmallBtn'}>
              Resend Approve
            </Button>
            <Button
              className={'roundSmallBtn'}
              onClick={() => this.setState({ visibleDrawer: true, abstract: record })}>
              Acceptance
            </Button>
            <Button
              className={'roundSmallBtn'}
              onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
              Abstract Activities
            </Button>
          </>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={`Approved Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={data => this.reloadTable(data)} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>

        {/*{this.state.visibleDrawer && (*/}
        {/*  <AcceptanceAbstractDrawer*/}
        {/*    visible={this.state.visibleDrawer}*/}
        {/*    abstract={this.state.abstract}*/}
        {/*    edit={true}*/}
        {/*    onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*    callback={this.reload}*/}
        {/*  />*/}
        {/*)}*/}
        {this.state.visibleDrawer && (
          <AcceptanceAbstractDrawer
            visible={this.state.visibleDrawer}
            abstract={this.state.abstract}
            edit={true}
            onClose={() => this.setState({ visibleDrawer: false })}
            callback={this.reload}
          />
        )}
        {this.state.visibleActivityList && (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            abstractNo={this.state.abstract.abstractNo || this.state.abstract.onlineAbstractId}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

export default connect(null)(ApprovedAbstract)
